import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Suppliers from "@/pages/Suppliers";
import PurchaseEntry from "@/pages/PurchaseEntry";
import PaymentEntry from "@/pages/PaymentEntry";
import BalanceReport from "@/pages/BalanceReport";
import SupplierAnalysis from "@/pages/SupplierAnalysis";
import Expenses from "@/pages/Expenses";
import DayLedger from "@/pages/DayLedger";
import Employees from "@/pages/Employees";
import SalaryDetail from "@/pages/SalaryDetail";
import Reports from "@/pages/Reports";
import PartyStatement from "@/pages/PartyStatement";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";

const pages = [
  ["/", <Dashboard />],
  ["/suppliers", <Suppliers />],
  ["/purchase", <PurchaseEntry />],
  ["/payment", <PaymentEntry />],
  ["/balance", <BalanceReport />],
  ["/analysis", <SupplierAnalysis />],
  ["/expenses", <Expenses />],
  ["/ledger", <DayLedger />],
  ["/employees", <Employees />],
  ["/salary", <SalaryDetail />],
  ["/party-statement", <PartyStatement />],
  ["/reports", <Reports />],
  ["/users", <Users />],
  ["/audit", <AuditLog />],
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            {pages.map(([path, el]) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute>
                    <Layout>{el}</Layout>
                  </ProtectedRoute>
                }
              />
            ))}
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
